module.exports = __webpack_public_path__ + "fonts/GT-Eesti-Display-Regular.05bbcb2.woff2";